import { Color, DoubleSide } from 'three';

import { EVENTS } from '../../constants.js';
import { globalUniforms } from '../../utils/uniforms.js';

import { lisa } from '../../Lisa.js';
import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';
import replacesVs from './replaces.vs?hotReplace';

export default class Cloth extends PBRMaterial {
	constructor(config, caller) {
		config.color = new Color(0xcec2ad);
		config.envMapIntensity = 2;
		super(config, caller);

		this.side = DoubleSide;

		// this.uniforms.uTime = globalUniforms.uTime;
		this.uniforms.tFabricNormal = { value: null };
		this.uniforms.uDarkMode = globalUniforms.uDarkMode;
		// this.transparent = true;
		replacesFs.use(this);

		replacesVs.use(this);
		lisa.state.on(EVENTS.ATTACH, this.#onAttach);
		lisa.state.on(EVENTS.DETACH, this.#onDetach);
	}
	#onAttach = () => {
		this.uniforms.tFabricNormal.value = lisa.scene.lisa.atlas.get('fabricNormalMap');
	};
	#onDetach() {
		lisa.state.off(EVENTS.ATTACH, this.#onAttach);
		lisa.state.off(EVENTS.DETACH, this.#onDetach);
	}
}
